import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import AppRoutes from "./routes";
import { store, persistor } from "./store";
import Loading from "./components/common/Loading";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <AppRoutes />
      </PersistGate>
    </Provider>
  );
}

export default App;
